export const RFQ_STATUS_PENDING = 'Pending';
export const RFQ_STATUS_STREAMING = 'Streaming';
export const RFQ_STATUS_EXPIRED = 'Expired';
export const RFQ_STATUS_ERROR = 'Error';
export const RFQ_STATUS_CANCELLED = 'Cancelled';
export const RFQ_STATUS_TRADED = 'Traded';
export const RFQ_STATUS_DECLINED = 'Declined';
export const RFQ_STATUS_WAITING = 'Waiting';
export const RFQ_STATUS_BLOCKED = 'Blocked';
export const RFQ_STATUS_RFE_PENDING = 'RFE Pending';

export const RFQ_PROVIDER_STATE_NO_RESPONSE = 'NO_RESPONSE';
export const RFQ_PROVIDER_STATE_UNQUOTED = 'UNQUOTED';
export const RFQ_PROVIDER_STATE_PICKED_UP = 'PICKED_UP';
export const RFQ_PROVIDER_STATE_EXPIRED = 'EXPIRED';
export const RFQ_PROVIDER_STATE_SENT = 'SENT';
export const RFQ_PROVIDER_STATE_DONE = 'DONE';
export const RFQ_PROVIDER_STATE_DECLINED = 'DECLINED';
export const RFQ_PROVIDER_STATE_INTERVENTION = 'INTERVENTION';

export const RFQ_SETUP_CHANGE = 'RFQ_SETUP_CHANGE';
export const RFQ_TOP_OF_BOOK = 'RFQ_TOP_OF_BOOK';
export const RFQ_VIEW_CHANGE = 'RFQ_VIEW_CHANGE';

export type RfqStatus =
  | typeof RFQ_STATUS_PENDING
  | typeof RFQ_STATUS_STREAMING
  | typeof RFQ_STATUS_EXPIRED
  | typeof RFQ_STATUS_ERROR
  | typeof RFQ_STATUS_CANCELLED
  | typeof RFQ_STATUS_WAITING
  | typeof RFQ_STATUS_TRADED
  | typeof RFQ_STATUS_RFE_PENDING
  | typeof RFQ_STATUS_BLOCKED;

export type RfqQuoteState =
  | typeof RFQ_PROVIDER_STATE_NO_RESPONSE
  | typeof RFQ_PROVIDER_STATE_UNQUOTED
  | typeof RFQ_PROVIDER_STATE_EXPIRED
  | typeof RFQ_PROVIDER_STATE_SENT
  | typeof RFQ_PROVIDER_STATE_DONE
  | typeof RFQ_PROVIDER_STATE_DECLINED
  | typeof RFQ_PROVIDER_STATE_PICKED_UP
  | typeof RFQ_PROVIDER_STATE_INTERVENTION;

export type RfqActions =
  | typeof RFQ_SETUP_CHANGE
  | typeof RFQ_TOP_OF_BOOK
  | typeof RFQ_VIEW_CHANGE;
